import angular from 'angular';

import { ParametersTagEditionController } from './parameters.tag.edition.controller.js';
import { ParametersCategoryEditionController } from './parameters.category.edition.controller.js';


ParametersTagGroupController.$inject = ['$scope', 'ParametersFactory', 'TopToolbarFactory', '$translate', '$state', '$stateParams', 'myTagGroup', 'AlertingFactory', '$uibModal', 'myTagGroups', 'loggedUser', 'company'];
export function ParametersTagGroupController($scope, ParametersFactory, TopToolbarFactory, $translate, $state, $stateParams, myTagGroup, AlertingFactory, $uibModal, myTagGroups, loggedUser, company) {

  init();
  $scope.goBackToList = goBackToList;
  $scope.updateTagGroup = updateTagGroup;
  $scope.addTag = addTag;
  $scope.addCategory = addCategory;
  $scope.editTagOrCategory = editTagOrCategory;
  $scope.deleteTagOrCategory = deleteTagOrCategory;
  $scope.addDependsUpon = addDependsUpon;
  $scope.setDependsUponTagGroup = setDependsUponTagGroup;
  $scope.setDependsUponTag = setDependsUponTag;
  $scope.deleteDependsUpon = deleteDependsUpon;
  $scope.enableSave = enableSave;

  function enableSave() {
    TopToolbarFactory.updateButtonDisable(false, $scope);
  }

  function deleteCategory(category) {
    ParametersFactory.deleteCategory($stateParams.companyId, $scope.myTagGroup.id, category.id)
      .then(function () {
        $scope.myTagGroup.tags_and_categories = $scope.myTagGroup.tags_and_categories.filter(item => item.id !== category.id);
        AlertingFactory.success('parameters/tags_groups/delete_category/ok');
        TopToolbarFactory.updateButtonDisable(true, $scope);
      }, function () {
        AlertingFactory.error('parameters/tags_groups/delete_category/ko');
      });
  }

  function deleteTag(tag, replacementTag) {
    ParametersFactory.deleteTag($stateParams.companyId, $stateParams.tagGroupId, tag.id, replacementTag.id)
      .then(function () {
        $scope.myTagGroup.tags_and_categories = $scope.myTagGroup.tags_and_categories.filter(item => item.id !== tag.id);
        AlertingFactory.success('parameters/tags_groups/delete_tag/ok');
        TopToolbarFactory.updateButtonDisable(true, $scope);
      }, function () {
        AlertingFactory.error('parameters/tags_groups/delete_tag/ko');
      });
  }

  function addDependsUpon() {
    let tag_id = myTagGroups[0].tags_and_categories.filter(i => !i.is_category)[0].id;
    if ($scope.myTagGroup.depends_upon === null) {
      $scope.myTagGroup.depends_upon = [];
    }
    $scope.myTagGroup.depends_upon.push({ tag_group_id: myTagGroups[0].id, tag_id: tag_id });
    TopToolbarFactory.updateButtonDisable(false, $scope);
  }

  function setDependsUponTagGroup(depends_upon, tg) {
    depends_upon.tag_group_id = tg.id;
    depends_upon.tag_id = tg.tags_and_categories.filter(i => !i.is_category)[0].id;
    TopToolbarFactory.updateButtonDisable(false, $scope);
  }

  function setDependsUponTag(depends_upon, tag) {
    depends_upon.tag_id = tag.id;
    TopToolbarFactory.updateButtonDisable(false, $scope);
  }

  function deleteDependsUpon(depends_upon) {
    $scope.myTagGroup.depends_upon = $scope.myTagGroup.depends_upon.filter(i => i !== depends_upon);
    TopToolbarFactory.updateButtonDisable(false, $scope);
  }

  function deleteTagOrCategory(el) {
    if (el.is_category) {
      let modalInstance = $uibModal.open({
        animation: true,
        template: require('../../confirmation/confirmation.modal.html'),
        controller: 'ConfirmationController',
        resolve: {
          text: function () {
            return 'parameters/tags_groups/confirmation/delete_category';
          }
        }
      });
      modalInstance.result.then(function () { deleteCategory(el); });
    } else {
      let modalInstance = $uibModal.open({
        animation: true,
        backdrop: 'static',
        template: require('./parameters.tag.deletion.html'),
        controller: ['$scope', 'tags', function ($scope, tags) {
          function setReplacementTag(tag) {
            $scope.replacementTag = tag;
          }
          $scope.setReplacementTag = setReplacementTag;
          $scope.tags = tags;
          // assert tags.length > 0 (none_tag_id is always there)
          $scope.replacementTag = tags[0];
        }],
        resolve: {
          tags: function () {
            return $scope.myTagGroup.tags_and_categories.filter(item => !item.is_category && item.id !== el.id);
          }
        }
      });
      modalInstance.result.then(function (result) {
        let replacementTag = result;
        let dependents = company.tags_groups
          .map(tg => tg.tags)
          .reduce((acc, tags) => acc.concat(tags), [])
          .map(t => t ? t.depends_upon : [])
          .reduce((acc, dus) => acc.concat(dus), [])
          .filter(du => du && (du.tag_id === el.id));
        if (!dependents.length) {
          // No dependents. Delete
          deleteTag(el, replacementTag);
        } else {
          let modal = $uibModal.open({
            backdrop: 'static',
            template: require('./parameters.tag.deletion.dependents.html'),
            controller: ['$scope', 'dependents', function ($scope, dependents) {
              $scope.dependents = dependents;
            }],
            resolve: {
              dependents: function () { return dependents; }
            }
          });
          modal.result.then(function () {
            // Dependents but the user has confirmed he is ok.
            deleteTag(el, replacementTag);
          });
        }
      }, function () {
      });
    }

  }


  function editTagOrCategory(el) {
    if (el.is_category) {
      let modalInstance = $uibModal.open({
        animation: true,
        template: require('./parameters.category.edition.html'),
        controller: ParametersCategoryEditionController,
        resolve: {
          category: function () {
            return el;
          },
          actionType: function () {
            return 'edition';
          }
        }
      });
      modalInstance.result.then(function (result) {
        let data = {
          'name_fr': result.nameFr,
          'name_en': result.nameEn,
          'name_es': result.nameEs,
          'name_nl': result.nameNl
        };
        ParametersFactory.updateCategory($stateParams.companyId, $scope.myTagGroup.id, el.id, data).then(function (result) {
          if (!angular.isUndefined(result.status) && !angular.isUndefined(result.data.error)) {
            AlertingFactory.error('parameters/tags_groups/update_category/ko');
          } else {
            let index = $scope.myTagGroup.tags_and_categories.findIndex(catTagObj => catTagObj.id === el.id);
            if (~index) {
              $scope.myTagGroup.tags_and_categories[index] = result;
            }
            AlertingFactory.success('parameters/tags_groups/update_category/ok');
          }
        });
      }, function () {
        //console.log('Modal dismissed at: ' + new Date());
      });
    } else {
      //the element is a tag
      let modalInstance = $uibModal.open({
        animation: true,
        template: require('./parameters.tag.edition.html'),
        controller: ParametersTagEditionController,
        windowClass: 'user-interactions',
        resolve: {
          tag: function () {
            return el;
          },
          actionType: function () {
            return 'edition';
          },
          company: function () {
            return company;
          },
          loggedUser: function () {
            return loggedUser;
          },
          group: function () {
            return myTagGroup;
          },
          groups: function () {
            return myTagGroups;
          }
        }
      });
      modalInstance.result.then(function (result) {
        ParametersFactory.updateTag($stateParams.companyId, $scope.myTagGroup.id, el.id, result).then(function (result) {
          if (!angular.isUndefined(result.status) && !angular.isUndefined(result.data.error)) {
            AlertingFactory.error('parameters/tags_groups/update_tag/ko');
          } else {
            let index = $scope.myTagGroup.tags_and_categories.findIndex(catTagObj => catTagObj.id === el.id);
            if (~index) {
              $scope.myTagGroup.tags_and_categories[index] = result;
            }
            AlertingFactory.success('parameters/tags_groups/update_tag/ok');
          }
        });
      }, function () {
        //console.log('Modal dismissed at: ' + new Date());
      });
    }

  }

  function addCategory() {
    let modalInstance = $uibModal.open({
      animation: true,
      template: require('./parameters.category.edition.html'),
      controller: ParametersCategoryEditionController,
      resolve: {
        category: function () {
          return undefined;
        },
        actionType: function () {
          return 'addition';
        }
      }
    });
    modalInstance.result.then(function (result) {
      let data = {
        'name_fr': result.nameFr,
        'name_en': result.nameEn,
        'name_es': result.nameEs,
        'name_nl': result.nameNl
      };
      ParametersFactory.addCategory($stateParams.companyId, $scope.myTagGroup.id, data).then(function (result) {
        if (!angular.isUndefined(result.status) && !angular.isUndefined(result.data.error)) {
          AlertingFactory.error('parameters/tags_groups/add_category/ko');
        } else {
          $scope.myTagGroup.tags_and_categories.push(result);
          AlertingFactory.success('parameters/tags_groups/add_category/ok');
        }
      });
    }, function () {
      //console.log('Modal dismissed at: ' + new Date());
    });
  }

  function addTag() {
    let modalInstance = $uibModal.open({
      animation: true,
      template: require('./parameters.tag.edition.html'),
      controller: ParametersTagEditionController,
      windowClass: 'user-interactions',
      resolve: {
        tag: function () {
          return undefined;
        },
        actionType: function () {
          return 'addition';
        },
        company: function () {
          return company;
        },
        loggedUser: function () {
          return loggedUser;
        },
        group: function () {
          return myTagGroup;
        },
        groups: function () {
          return myTagGroups;
        }
      }
    });
    modalInstance.result.then(function (result) {
      ParametersFactory.addTag($stateParams.companyId, $scope.myTagGroup.id, result).then(function (result) {
        if (!angular.isUndefined(result.status) && !angular.isUndefined(result.data.error)) {
          AlertingFactory.error('parameters/tags_groups/add_tag/ko');
        } else {
          $scope.myTagGroup.tags_and_categories.push(result);
          AlertingFactory.success('parameters/tags_groups/add_tag/ok');
        }
      });
    }, function () {
      //console.log('Modal dismissed at: ' + new Date());
    });
  }

  function updateTagGroup() {
    let data = {
      'name_fr': $scope.myTagGroup.name_fr,
      'name_en': $scope.myTagGroup.name_en,
      'name_es': $scope.myTagGroup.name_es,
      'name_nl': $scope.myTagGroup.name_nl,
      'is_routing': $scope.myTagGroup.is_routing,
      'is_mandatory': $scope.myTagGroup.is_mandatory,
      'depends_upon': $scope.myTagGroup.depends_upon
    };
    ParametersFactory.updateTagGroup($stateParams.companyId, $scope.myTagGroup.id, data).then(function (result) {
      if (!angular.isUndefined(result.status) && !angular.isUndefined(result.data.error)) {
        AlertingFactory.error('parameters/tags_groups/update_tag_group/ko');
      } else {
        AlertingFactory.success('parameters/tags_groups/update_tag_group/ok');
        TopToolbarFactory.updateButtonDisable(true, $scope);
      }
    });
  }

  function goBackToList() {
    $state.go('auth.alcmeon.parameters.tags-groups', null, {
      'reload': 'auth.alcmeon.parameters.tags-groups'
    });
  }

  function init() {
    $scope.lang = (!angular.isUndefined(loggedUser.lang)) ? loggedUser.lang : 'en';

    const tagGroupName = myTagGroup[`name_${$scope.lang}`] ? myTagGroup[`name_${$scope.lang}`] : myTagGroup['name_en'];
    const title = `${$translate.instant('parameters/tags_groups/tags')} > ${tagGroupName}`;
    TopToolbarFactory.setTitle(title, $scope);
    TopToolbarFactory.setButton('save', updateTagGroup, $scope);
    TopToolbarFactory.updateButtonDisable(true, $scope);

    $scope.myTagGroups = myTagGroups;
    $scope.myTagGroup = myTagGroup;
    //Filtering results in order to display only what we need
    $scope.myTagGroup.tags_and_categories = $scope.myTagGroup.tags_and_categories.map(tagObj => (tagObj.state === 'active' || tagObj.state === 'deleting') ? tagObj : null).filter(tagObj => tagObj !== null);
    $scope.myTagGroup.tags_and_categories.sort((a, b) => a.display_order - b.display_order);
    $scope.companyHasRoutingTag = (myTagGroups.find(tagGroupObj => ((tagGroupObj.is_routing === 1) && (tagGroupObj.id !== $scope.myTagGroup.id)))) ? true : false;
    //Setting boolean values for checkbox
    $scope.myTagGroup.is_routing = ($scope.myTagGroup.is_routing) ? true : false;
    $scope.myTagGroup.is_mandatory = ($scope.myTagGroup.is_mandatory) ? true : false;

    //Sortable js block
    $scope.myTagGroup.tags_and_categories.sort(function (a, b) {
      return a.display_order > b.display_order;
    });
    $scope.sortableOptions = {
      stop: function (e, ui) {
        for (let index in $scope.myTagGroup.tags_and_categories) {
          $scope.myTagGroup.tags_and_categories[index].display_order = index;
          let update = {
            'display_order': index
          };
          if ($scope.myTagGroup.tags_and_categories[index].is_category) {
            ParametersFactory.updateCategory($stateParams.companyId, $scope.myTagGroup.id, $scope.myTagGroup.tags_and_categories[index].id, update).then(function (result) {
              if (!angular.isUndefined(result.status) && !angular.isUndefined(result.data.error.reason)) {
                AlertingFactory.error('parameters/tags_groups/update_category/ko');
              } else {
                AlertingFactory.success('parameters/tags_groups/update_category/ok');
              }
            });
          } else {
            ParametersFactory.updateTag($stateParams.companyId, $scope.myTagGroup.id, $scope.myTagGroup.tags_and_categories[index].id, update).then(function (result) {
              if (!angular.isUndefined(result.status) && !angular.isUndefined(result.data.error.reason)) {
                AlertingFactory.error('parameters/tags_groups/update_tag/ko');
              } else {
                AlertingFactory.success('parameters/tags_groups/update_tag/ok');
              }
            });
          }
        }
        $scope.myTagGroup.tags_and_categories.sort((a, b) => a.display_order - b.display_order);
      }
    };
  }

}

